import { api } from "@/lib/api";

// Custom Google OAuth 2.0 (Authorization Code flow) using the app's own GOOGLE_CLIENT_ID.
export async function startGoogleLogin() {
  const { data } = await api.get("/auth/google/config");
  if (!data.configured || !data.client_id) {
    throw new Error("Google sign-in is not configured yet. Please try again later.");
  }
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUri = window.location.origin + "/auth/google";
  const state = Math.random().toString(36).slice(2) + Date.now().toString(36);
  sessionStorage.setItem("g_oauth_state", state);
  const params = new URLSearchParams({
    client_id: data.client_id,
    redirect_uri: redirectUri,
    response_type: "code",
    scope: "openid email profile",
    state,
    access_type: "online",
    prompt: "select_account",
    include_granted_scopes: "true",
  });
  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
}
